export default __webpack_public_path__ + "static/media/checked.bda85631.png";